<fury-page-layout mode="card">
    <fury-page-layout-header>
      <div class="header_sec">
        <fury-breadcrumbs [@fadeInRight] [crumbs]="['File Claim', 'Purchased Claim']"  current={{filterValue}}></fury-breadcrumbs>
      </div>
    </fury-page-layout-header>
    
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name={{filterValue}} [columns]="columns" [hideSearchInput]="true" style="position: relative;">
        <div class="actions">
            <button class="create" type="button" mat-mini-fab color="primary" (click)="handlePurchaseItemModal(true)">
                <mat-icon>add</mat-icon>
            </button>
        </div>
          <div class="table_container">
            
            <table class="lead_list" [dataSource]="dataSource" mat-table>
              <form [formGroup]="purchaseItem">
              <!-- actions Column -->
              <ng-container matColumnDef="actions" stickyEnd>
                  <th *matHeaderCellDef class="actions-cell" mat-header-cell>
                      <div>
                          <div class="search" (click)="getPurchaseClaimsItems()">
                              <mat-icon>search</mat-icon>
                          </div>
                      </div>
                      <h3>
                          Actions
                      </h3>
                  </th>
                 <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                      <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                          (click)="$event.stopPropagation()">
                          <mat-icon>more_horiz</mat-icon>
                      </button>
                      <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                          <button mat-menu-item (click)="handlePurchaseItemModal(false, row)">
                              <span>Edit</span>
                          </button>
                      </mat-menu>
                  </td>
              </ng-container>
              
              <ng-container matColumnDef="itemName">
                <th mat-header-cell *matHeaderCellDef>
                  <div>
                      <input type="text" placeholder="Covered Item" formControlName="itemName"/>
                      <h3>
                          Covered Item
                      </h3>
                  </div>
              </th>
                <td mat-cell *matCellDef="let element">
                    {{element?.itemName}}
                </td>
              </ng-container>
  
              <ng-container matColumnDef="itemParts">
                  <th mat-header-cell *matHeaderCellDef>
                      <div>
                          <input type="text" placeholder=" Item Parts" formControlName="itemParts"/>
                          <h3>
                            Item Parts
                          </h3>
                      </div>
                  </th>
                <td mat-cell *matCellDef="let element">
                    {{element?.itemParts}}
                </td>
              </ng-container>
  
              <ng-container matColumnDef="color">
                  <th mat-header-cell *matHeaderCellDef>
                      <div>
                          <input type="text" placeholder="Color" formControlName="color"/>
                          <h3>
                              Color
                          </h3>
                      </div>
                  </th>
                  <td mat-cell *matCellDef="let element">
                      {{element?.color}}
                  </td>
              </ng-container>
  
              <ng-container matColumnDef="supplier">
                  <th mat-header-cell *matHeaderCellDef>
                      <div>
                          <input type="text" placeholder="Supplier" formControlName="supplier"/>
                          <h3>
                              Supplier
                          </h3>
                      </div>
                  </th>
                  <td mat-cell *matCellDef="let element">
                      {{element?.supplier}}
                  </td>
              </ng-container>
              <ng-container matColumnDef="orderNumber">
                  <th mat-header-cell *matHeaderCellDef>
                      <div>
                          <input type="text" placeholder="Order Number" formControlName="orderNumber"/>
                          <h3>
                              Order Number
                          </h3>
                      </div>
                  </th>
                  <td mat-cell *matCellDef="let element">
                      {{element?.orderNumber}}
                  </td>
              </ng-container>
              <ng-container matColumnDef="orderDate">
                  <th mat-header-cell *matHeaderCellDef>
                      <div>
                          <input type="text" placeholder="Order Date" style="visibility: hidden;"/>
                          <h3>
                              Order Date
                          </h3>
                      </div>
                      
                  </th>
                  <td mat-cell *matCellDef="let element">
                      {{element?.orderDate | date : 'MMM-dd-YYYY'}}
                  </td>
              </ng-container>
              <ng-container matColumnDef="totalAmount">
                  <th mat-header-cell *matHeaderCellDef>
                      <div>
                          <input type="text" placeholder="Total Amount" formControlName="totalAmount"  mask="separator.2" thousandSeparator=","/>
                          <h3>
                              Total Amount
                          </h3>
                      </div>
                  </th>
                  <td mat-cell *matCellDef="let element">
                      {{element?.totalAmount | currency}}
                  </td>
              </ng-container>
              <ng-container matColumnDef="deliveryDate">
                  <th mat-header-cell *matHeaderCellDef>
                      <div>
                          <input type="text" placeholder="Delivery Date"  style="visibility: hidden;"/>
                          <h3>
                            Delivery Date
                          </h3>
                      </div>
                  </th>
                  <td mat-cell *matCellDef="let element">
                      {{element?.deliveryDate | date : 'MMM-dd-YYYY'}}
                  </td>
              </ng-container>
              <ng-container matColumnDef="tracking">
                  <th mat-header-cell *matHeaderCellDef>
                      <div>
                          <input type="text" placeholder="Tracking" formControlName="tracking"/>
                          <h3>
                              Tracking
                          </h3>
                      </div>
                  </th>
                  <td mat-cell *matCellDef="let element">
                      {{element?.tracking}}
                  </td>
              </ng-container>
  
          <ng-container matColumnDef="status">
              <th *matHeaderCellDef mat-header-cell>
                  <div>
                      <select formControlName="status">
                        <option value="">Status</option>
                        <option *ngFor="let item of statusList" [value]="item">{{item}}</option>
                    </select>
                      <h3>
                          Status
                      </h3>
                  </div>
              </th>
              <td mat-cell *matCellDef="let element">
                {{element?.status}}
            </td>
          </ng-container>
          <ng-container matColumnDef="note">
            <th mat-header-cell *matHeaderCellDef>
                <div>
                    <input type="text" placeholder="Note"  style="visibility: hidden;"/>
                    <h3>
                     Note
                    </h3>
                </div>
            </th>
            <td mat-cell *matCellDef="let element" [title]="element?.specialNotes">
                <span class="maxTxt">{{element?.specialNotes}}</span>
            </td>
        </ng-container>
  
              <tr *matHeaderRowDef="visibleColumns; sticky: true" mat-header-row></tr>
              <tr *matRowDef="let row; columns: visibleColumns"
                  class="clickable route-animations-elements" mat-row>
              </tr>
          </form>
            </table>
          </div>
       
        <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
            No data found.
        </div>
        <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
            showFirstLastButtons
            [selectConfig] = "selectConfig"
            [ngClass]="{'mat-pegig': pageSize === 9999}"
            aria-label="Select page of periodic elements" *ngIf="itemList?.length > 0">
        </mat-paginator>
  
      </fury-list>
  
    </fury-page-layout-content>
  </fury-page-layout>
  